import React, { useState, useEffect } from "react";
import TenantService from "../../services/core/TenantService";
import MeService from "../../services/core/MeService";

const TenantSelector = () => {
  const [tenants, setTenants] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetchTenants();

    // Listen for tenant reload event
    const handleTenantsUpdated = () => {
      fetchTenants();
    };
    window.addEventListener("tenantsUpdated", handleTenantsUpdated);

    return () => {
      window.removeEventListener("tenantsUpdated", handleTenantsUpdated);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTenants = async () => {
    try {
      // Primero obtener el usuario desde /api/me
      const me = await MeService.me();
      
      // Si es superuser, obtener todos los tenants
      if (me?.superuser) {
        const response = await TenantService.getAll(0, 100, { enabled: true });
        const allTenants = response.content || [];
        const activeTenants = allTenants.filter((tenant) => tenant.enabled === true);
        setTenants(activeTenants);
        
        const savedTenantId = localStorage.getItem("selectedTenant");
        if (savedTenantId) {
          const tenant = activeTenants.find((t) => String(t.id) === String(savedTenantId));
          if (tenant) {
            setSelectedTenant(tenant);
          } else if (activeTenants.length > 0) {
            setSelectedTenant(activeTenants[0]);
            localStorage.setItem("selectedTenant", String(activeTenants[0].id));
          }
        } else if (activeTenants.length > 0) {
          setSelectedTenant(activeTenants[0]);
          localStorage.setItem("selectedTenant", String(activeTenants[0].id));
        }
      } else {
        // Usuario normal: usar tenants de /api/me
        const userTenants = me?.tenants || [];
        setTenants(userTenants);
        
        const savedTenantId = localStorage.getItem("selectedTenant");
        if (savedTenantId) {
          const tenant = userTenants.find((t) => String(t.tenantId) === String(savedTenantId));
          if (tenant) {
            setSelectedTenant(tenant);
          } else if (userTenants.length > 0) {
            setSelectedTenant(userTenants[0]);
            localStorage.setItem("selectedTenant", String(userTenants[0].tenantId));
          }
        } else if (userTenants.length > 0) {
          setSelectedTenant(userTenants[0]);
          localStorage.setItem("selectedTenant", String(userTenants[0].tenantId));
        }
      }
    } catch (error) {
      console.error("Error loading tenants:", error);
    }
  };

  const handleTenantChange = (tenant) => {
    setSelectedTenant(tenant);
    const tenantId = tenant?.tenantId ?? tenant?.id;
    localStorage.setItem("selectedTenant", String(tenantId));
    setIsOpen(false);

    // Dispatch event for components that need to know about tenant change
    const event = new CustomEvent("tenantChanged", {
      detail: { tenantId: tenantId },
    });
    window.dispatchEvent(event);
  };

  if (tenants.length <= 1) {
    return null;
  }

  return (
    <div className="tenant-selector-dropdown">
      <button
        className="tenant-toggle"
        onClick={() => setIsOpen(!isOpen)}
        title={selectedTenant?.name || selectedTenant?.nombre || ""}
      >
        <span className="tenant-name">
          {selectedTenant?.name || selectedTenant?.nombre || "Tenant"}
        </span>
        <i
          className={`fa fa-chevron-down tenant-chevron ${isOpen ? "open" : ""}`}
        ></i>
      </button>

      {isOpen && (
        <>
          <div
            className="tenant-overlay"
            onClick={() => setIsOpen(false)}
          ></div>
          <div className="tenant-menu">
            {tenants.map((tenant) => (
              <button
                key={tenant.id}
                className={`tenant-item ${selectedTenant?.id === tenant.id ? "active" : ""}`}
                onClick={() => handleTenantChange(tenant)}
              >
                <i className="fa fa-sitemap"></i>
                <span className="tenant-full-name">{tenant.name ?? tenant.nombre ?? tenant.code}</span>
                {selectedTenant?.id === tenant.id && (
                  <i className="fa fa-check tenant-check"></i>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TenantSelector;
